const DevelopmentTag = () => {
  const isDev = window.location.hostname.includes("dev");
  // const isDev = window.location.hostname.includes("localhost");
  if (!isDev) return null;
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 bg-orange-500 text-white font-bold text-xs px-3 py-1 rounded shadow-lg z-50">
      Development
    </div>
  );
};

export default DevelopmentTag;
